import {DATETIME_FORMATS} from 'util/DateUtil';

// audit logs
export const EXPORT_AUDIT_LOG_DISPLAY_STRING = 'Export audit log';
export const EXPORT_AUDIT_LOG_MODAL_TITLE = 'Select format for audit log export';

// sample container history
export const EXPORT_SAMPLE_CONTAINER_HISTORY_DISPLAY_STRING = 'Export chain of custody - container history';
export const EXPORT_SAMPLE_CONTAINER_HISTORY_MODAL_TITLE = 'Select format for container history report';

// plate history
export const EXPORT_PLATE_HISTORY_DISPLAY_STRING = 'Export chain of custody - plate history';
export const EXPORT_PLATE_HISTORY_MODAL_TITLE = 'Select format for plate history report';
export const EXPORT_PLATE_HISTORY_ERROR_TOOLTIP = 'Please select exactly one plate.';

// location history
export const EXPORT_LOCATION_HISTORY_DISPLAY_STRING = 'Export location history';
export const EXPORT_LOCATION_HISTORY_MODAL_TITLE = 'Select format and date range for location history report';
export const EXPORT_LOCATION_HISTORY_ERROR_TOOLTIP = 'Report can only be exported for locations.';
export const LOCATION_HISTORY_TIME_RANGE_TOOLTIP =
  'The optional start and end dates limit the time period of the report. The report will include all entities and inventory objects that are present in the location during this time range.';

// datetime
export const EXPORT_AUDIT_LOG_MODAL_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm A';
export const ALL_EXPORT_AUDIT_LOG_MODAL_DATETIME_FORMATS = [
  EXPORT_AUDIT_LOG_MODAL_DATETIME_FORMAT,
  ...DATETIME_FORMATS,
];
